import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    marginBottom: 4,

    maxWidthTabletSm: {
      marginBottom: '0',
    },
  },
});

export default styles;
